import { requestApi } from '@/utils/request'
import { UserRole } from '@/constants/user'

export const findUser = (query) =>
  requestApi({
    method: 'GET',
    endpoint: `/v2/find-user`,
    params: query,
  })

export const updateUser = (userId, data) => {
  return requestApi({
    method: 'PUT',
    endpoint: `/v2/update-user/${userId}`,
    data,
  })
}

export const allUser = (query) =>
  requestApi({
    method: 'get',
    endpoint: '/v2/all-user',
    params: query,
  })

export const searchUser = async ({ searchText, roles, ...args }) => {
  if (!searchText || searchText.trim().length < 2) {
    return []
  }

  const params = {
    keyword: searchText.trim(),
    roles: JSON.stringify(
      Array.isArray(roles)
        ? roles
        : [
            UserRole.ADMINISTRATOR,
            UserRole.AGENT,
            UserRole.SUPERVISOR,
            UserRole.TEAM_LEADER,
          ],
    ),
    ...args,
  }

  const { data } = await requestApi({
    method: 'get',
    endpoint: '/v2/all-user',
    params,
  })

  return data?.list ?? []
}

export const getUserTemplate = (userId) =>
  requestApi({
    method: 'get',
    endpoint: `/v2/templates/user/${userId}`,
  })

export const getUserGroups = () =>
  requestApi({
    method: 'get',
    endpoint: `v2/all-group?target=user`,
  })

export const resetPassword = ({ userId, data }) => {
  return requestApi({
    method: 'post',
    endpoint: `/v2/reset-password/${userId}`,
    data,
  })
}

export const getTenantConfig = () => {
  return requestApi({
    method: 'get',
    endpoint: `/v2/my-account`,
  })
}

export const getUserInfo = (userId) => {
  return requestApi({
    method: 'get',
    endpoint: `/v2/users/${userId}`,
  })
}

export function activeUser({ id, data }) {
  return requestApi({
    method: 'put',
    endpoint: `/v2/active-user/${id}`,
    data,
  })
}

export function activeManyUser({ data }) {
  return requestApi({
    method: 'post',
    endpoint: `/v2/active-users`,
    data,
  })
}

export function disableUser({ id, data }) {
  return requestApi({
    method: 'put',
    endpoint: `/v2/disable-user/${id}`,
    data,
  })
}

export function disableManyUser({ data }) {
  return requestApi({
    method: 'post',
    endpoint: `/v2/disable-users`,
    data,
  })
}

export function getListAgents({ params }) {
  return requestApi({
    method: 'get',
    endpoint: '/v2/list-agents',
    params,
  })
}
